import { render, staticRenderFns } from "./usersSidebar.vue?vue&type=template&id=47a42d3a"
import script from "./usersSidebar.vue?vue&type=script&lang=js"
export * from "./usersSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports